// Platform-owned Meta Pixels, as opposed to a venue's own tags in
// venue_analytics_tags. Every venue page loads all of them.
export const PUNCHUP_META_PIXEL_ID = "857308485465982";
export const TIXOLOGI_META_PIXEL_ID = "9401175393316443";

export const VENUE_PAGE_PLATFORM_META_PIXEL_IDS = [
  PUNCHUP_META_PIXEL_ID,
  TIXOLOGI_META_PIXEL_ID,
] as const;
